module.exports = __webpack_public_path__ + "images/checkGrayIconWhiteFill-026212bdfc5d8ca1011334867d222e33.svg";